export default "__VITE_ASSET__8kyfKgj6__"